import { render, staticRenderFns } from "./Stack.vue?vue&type=template&id=154fa54e&scoped=true&"
import script from "./Stack.vue?vue&type=script&lang=js&"
export * from "./Stack.vue?vue&type=script&lang=js&"
import style0 from "./Stack.vue?vue&type=style&index=0&id=154fa54e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154fa54e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('154fa54e')) {
      api.createRecord('154fa54e', component.options)
    } else {
      api.reload('154fa54e', component.options)
    }
    module.hot.accept("./Stack.vue?vue&type=template&id=154fa54e&scoped=true&", function () {
      api.rerender('154fa54e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/Stack.vue"
export default component.exports